const nav = document.querySelector('.s7-nav');
const backdrop = document.querySelector('.s7-nav__backdrop');

if (nav) {
  const xl = window.matchMedia('(min-width: 1200px)');

  const syncDesktopState = (isDesktop) => {
    if (isDesktop) {
      nav.removeAttribute('inert');
      nav.removeAttribute('aria-hidden');
    } else if (!nav.classList.contains('is-open')) {
      nav.setAttribute('inert', '');
      nav.setAttribute('aria-hidden', 'true');
    }
  };

  const openNav = () => {
    nav.classList.add('is-open');
    backdrop?.classList.add('s7-nav__backdrop--open');
    nav.removeAttribute('inert');
    nav.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nav-is-open');
  };

  const closeNav = () => {
    nav.classList.remove('is-open');
    backdrop?.classList.remove('s7-nav__backdrop--open');
    nav.setAttribute('inert', '');
    nav.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nav-is-open');
  };

  xl.addEventListener('change', (e) => syncDesktopState(e.matches));
  syncDesktopState(xl.matches);

  document.querySelectorAll('[data-action="toggle-nav"]').forEach((btn) => {
    btn.addEventListener('click', openNav);
  });

  document.querySelectorAll('[data-action="close-nav"]').forEach((btn) => {
    btn.addEventListener('click', closeNav);
  });

  document.querySelectorAll('.s7-nav__expand').forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.s7-nav__item');
      const dropdown = item?.querySelector('.s7-nav-dropdown');
      const isOpen = btn.classList.contains('s7-nav__expand--open');

      document.querySelectorAll('.s7-nav__expand--open').forEach((openBtn) => {
        openBtn.classList.remove('s7-nav__expand--open');
        openBtn.setAttribute('aria-expanded', 'false');
        openBtn
          .closest('.s7-nav__item')
          ?.querySelector('.s7-nav-dropdown')
          ?.classList.remove('s7-nav-dropdown--open');
      });

      if (!isOpen) {
        btn.classList.add('s7-nav__expand--open');
        btn.setAttribute('aria-expanded', 'true');
        dropdown?.classList.add('s7-nav-dropdown--open');
      }
    });
  });
}
